import Application from '@ember/application';
import config from 'uplisting-frontend/config/environment';

export async function initialize(app: Application): Promise<void> {
  app.deferReadiness();

  window.psl = await import('psl');
  if (!config.IS_TEST) {
    window.Sentry = await import('@sentry/ember');
  }

  app.advanceReadiness();
}

export default {
  name: 'load-externals',
  before: 'tracking',
  initialize,
};
